import Glider from 'glider-js/glider'; 

export default {
  init() {
    // JavaScript to be fired on all pages
  },
  finalize() {
    let gliderPromoSingle = document.querySelectorAll('.js-single-promo');
    if (gliderPromoSingle){ 
      gliderPromoSingle.forEach(element => {
        new Glider(element, {
            slidesToShow: 1,
            dots: element.nextElementSibling.querySelector('.js-single-dots'),
            draggable: true, 
            arrows: {
              prev: element.nextElementSibling.querySelector('.js-single-card-prev.glider-prev'),
              next: element.nextElementSibling.querySelector('.js-single-card-next.glider-next'),
            },
        });
      });
    }

    // let gliderCardPromo = document.querySelectorAll('.js-card-promo');
    // if(gliderCardPromo){
    //   gliderCardPromo.forEach(element => {
    //     new Glider(element, {
    //       slidesToShow: 1,
    //       dots: element.nextElementSibling.querySelector('.js-card-dots'),
    //       draggable: true,
    //       arrows: {
    //         prev: element.nextElementSibling.querySelector('.js-card-prev.glider-prev'),
    //         next: element.nextElementSibling.querySelector('.js-card-next.glider-next'),
    //       },
    //     }); 
    //   }); 
    // }

    let promoForm = document.querySelector('.js-single-promo-form');
    if (promoForm) {
      let data_promo = promoForm.dataset.promo;
      promoForm.querySelector('.Form__Field--Object').value = data_promo;
    }
  },
};



// WEBPACK FOOTER //
// ./scripts/routes/single-promo.js